import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import Punctures from "./Punctures";
import Inspections from "./Inspections";
import Alerts from "./Alerts";
import Reports from "./Reports";

export default function Activity() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "punctures";
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Activity</h1>
        <p className="mt-1 text-sm text-zinc-400">Puncture reports, inspections, alerts and reports — all in one place.</p>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="flex-wrap bg-zinc-900">
          <TabsTrigger value="punctures" data-testid="tab-punctures">Puncture Reports</TabsTrigger>
          <TabsTrigger value="inspections" data-testid="tab-inspections">Inspections</TabsTrigger>
          <TabsTrigger value="alerts" data-testid="tab-alerts">Alerts</TabsTrigger>
          <TabsTrigger value="reports" data-testid="tab-reports">Reports</TabsTrigger>
        </TabsList>
        <TabsContent value="punctures" className="mt-6"><Punctures /></TabsContent>
        <TabsContent value="inspections" className="mt-6"><Inspections /></TabsContent>
        <TabsContent value="alerts" className="mt-6"><Alerts /></TabsContent>
        <TabsContent value="reports" className="mt-6"><Reports /></TabsContent>
      </Tabs>
    </div>
  );
}
